<div class="d-flex justify-content-between align-items-center m-0 p-2 inventar_li">
  <a class="d-flex justify-content-between w-100" (click)="selectInventar(inventar)"
    [routerLink]="inventarRouterLink">
    <span style="flex: 1">{{inventar.name}}</span>
    <span style="flex: 1; text-align: center;">{{inventar.createdAt | date: 'dd/MM/yyyy HH:mm:ss'}}</span>
    <span style="flex: 1; text-align: end;" *ngIf="inventar.status === 'finished'" translate>filials.filial.finished<i
        class='bx bxs-lock ms-2'></i></span>
    <span style="flex: 1; text-align: end;" *ngIf="inventar.status === 'active'" translate>filials.filial.inProgress</span>
    <span style="flex: 1; text-align: end;" *ngIf="inventar.status === 'permanent'" translate>global.permanent</span>
    <i *ngIf="inventar.status !== 'finished' && inventar.reason" class="fa fa-refresh ms-2 mt-1"
      ngbTooltip="Open reason: {{inventar.reason}}"></i>
  </a>
  <!-- dropdown -->
  <div *ngIf="currentUser.role.name !== 'worker'" class="dropdown d-flex justify-content-end ms-3">
    <i class='bx bx-dots-vertical-rounded orange' style="font-size: 1.5rem; padding: 5px; cursor: pointer;"
      id="dropdownMenuButton1" data-bs-toggle="dropdown" aria-expanded="false"></i>
    <ul class="dropdown-menu" aria-labelledby="dropdownMenuButton1">
      <li *ngIf="inventar.status !== 'finished' && inventar.status !== 'permanent'"><a class="dropdown-item" (click)="onFinish(inventar)"
          translate>filials.filial.finish<i class='bx bxs-lock ms-2'></i></a></li>
      <li *ngIf="inventar.status === 'finished'"><a class="dropdown-item" (click)="onFinish(inventar)" translate>filials.filial.openInventar<i
            class='bx bxs-lock-open ms-2'></i></a></li>
      <li><a class="dropdown-item" (click)="onEdit(inventar)" translate>global.edit</a></li>
      <li><a class="dropdown-item" (click)="onWorkers(inventar)" translate>workers.workers</a></li>
      <!-- <li><a class="dropdown-item" (click)="onImportCsv(inventar)" translate>Import CSV</a> -->
      <li *ngIf="inventar.status === 'finished' || inventar.status === 'permanent'"><a class="dropdown-item" (click)="onDownloadCsv(inventar)"
          translate>filials.filial.downloadCSV</a>
      </li>
      <li *ngIf="inventar.status === 'permanent'"><a class="dropdown-item" (click)="onCopyInventar(inventar)"
        translate>global.copy</a></li>
      <li *ngIf="['root', 'user'].includes(currentUser.role.name)"><a class="dropdown-item" (click)="onDelete(inventar)"
          translate>global.delete<i class="fa fa-trash ms-2"></i></a></li>
      <li *ngIf="this.currentUser.role.name !== 'worker'"><button class="dropdown-item"
          (click)="openModalLogActivity(inventar)" translate>filials.filial.activityLog</button></li>
      <li *ngIf="this.currentUser.role.name === 'root'"><button class="dropdown-item"
        (click)="getDetails(inventar)" translate>filials.details</button></li>
    </ul>
  </div>
  <!-- /dropdown -->
</div>

<app-activity-log #dialogActivityLog [activeLogList]="activeLogList"></app-activity-log>

<app-modal (close)="toggleWorkers = false;" *ngIf="toggleWorkers">
  <div class="modal_container"
    style="text-align: initial; font-weight: 300 !important; letter-spacing: initial; font-size: 1rem; color: #15171a;">
    <div class="modal-header">
      <h4 class="modal-title" style="font-size: 1rem; font-weight: inherit;" translate>filials.assignedFilials</h4>
    </div>
    <div class="modal-body">
      <div class="d-flex justify-content-between mb-2 align-items-center">
        <select class="form-control" name="inventar" [(ngModel)]="selectedWorkerId">
          <option value="" disabled translate>workers.selectWorker</option>
          <option *ngFor="let worker of workers" [value]="worker.id">{{worker.name}}hm</option>
        </select>
        <button class="custom_button" (click)="assignWorkerToInventar()" translate>global.assign</button>
      </div>
      <div *ngIf="!assignedWorkers.length" translate>workers.noAssignedWorkers</div>
      <div *ngIf="assignedWorkers.length" translate>workers.assignedWorkers</div>
      <ng-container *ngFor="let worker of assignedWorkers">
        <div class="d-flex justify-content-between mb-2 align-items-center list_container">
          <span>{{worker.name}}</span>
          <button class="custom_button" (click)="unassignWorker(worker)">X</button>
        </div>
      </ng-container>
    </div>
  </div>
</app-modal>


<app-modal (close)="toggleDetails = !toggleDetails" *ngIf="toggleDetails">
  <div class="modal_container"
    style="text-align: initial; font-weight: 300 !important; letter-spacing: 1px; color: #15171a;">
    <div class="modal-header">
      <h4 class="modal-title" style="font-size: 1rem; font-weight: inherit;" translate>Inventar: {{inventar?.name}}</h4>
    </div>
    <div class="modal-body">
      <p style="font-size: 1rem; font-weight: inherit;">Company: {{company?.name}}</p>
      <p style="font-size: 1rem; font-weight: inherit;">Filial: {{filial?.name}}</p>
    </div>
  </div>
</app-modal>